// Identidade do usuário logado (profile do Supabase), no mesmo padrão dos
// caches hidratados: hydrateCurrentUser() roda no login (hydrateAll) e os
// getters síncronos ficam disponíveis para uso em render e handlers.
import { supabase } from "@/integrations/supabase/client";

let _id: string | null = null;
let _name: string | null = null;
let _email: string | null = null;
let _avatarUrl: string | null = null;

export async function hydrateCurrentUser(): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      _id = null;
      _name = null;
      _email = null;
      _avatarUrl = null;
      return;
    }
    _id = user.id;
    _email = user.email ?? null;
    const { data: profile, error } = await supabase
      .from("profiles")
      .select("full_name, email, avatar_url")
      .eq("id", user.id)
      .maybeSingle();
    if (error) console.error("hydrateCurrentUser profile:", error.message);
    const metaName = (user.user_metadata?.full_name as string | undefined) ?? null;
    _name = profile?.full_name || metaName || user.email || null;
    _avatarUrl = profile?.avatar_url ?? null;
  } catch (e) {
    console.error("hydrateCurrentUser:", e);
  }
}

/** ID do usuário logado — usado pelo filtro "Minhas tarefas". */
export const getCurrentUserId = (): string | null => _id;
export const getCurrentUserName = (): string => _name ?? "Usuário";
export const getCurrentUserEmail = (): string | null => _email;
export const getCurrentUserAvatarUrl = (): string | null => _avatarUrl;
